import React from 'react';
import { TWCPage } from '@components';
import { useRecoilValue } from 'recoil';

import { dailyWeatherPageTestIDs } from '@constants';
import { dailyForecastState, screenReaderEnabledState } from '@store';

import { DailyWeatherPageContent } from './DailyWeatherPageContent/DailyWeatherPageContent';

export const DailyWeatherConditionsPage = () => {
  const { data, error, isLoading } = useRecoilValue(dailyForecastState);
  const screenReaderEnabled = useRecoilValue(screenReaderEnabledState);

  return (
    <TWCPage
      childIds={[
        dailyWeatherPageTestIDs.dailyWeatherTopRow,
        dailyWeatherPageTestIDs.dailyWeatherMiddleRowToday,
        dailyWeatherPageTestIDs.dailyWeatherMiddleRowTomorrow,
        dailyWeatherPageTestIDs.dailyWeatherBottomRow,
        dailyWeatherPageTestIDs.dailyWeatherTiles,
      ]}
      firstFocus={
        screenReaderEnabled ? dailyWeatherPageTestIDs.dailyWeatherTopRow : dailyWeatherPageTestIDs.dailyWeatherTiles
      }
      isMenuItem={false}
      pageID={dailyWeatherPageTestIDs.dailyWeatherPage}
    >
      <DailyWeatherPageContent data={data} error={error} isLoading={isLoading} />
    </TWCPage>
  );
};
